var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"LeftNav"}},[_c('div',{staticClass:"left_nav custom_scrollbar main_menu"},[_c('div',{staticClass:"nav_wrapper"},[_c('navigation',{attrs:{"user":_vm.getUser}}),_vm._v(" "),_c('div',{staticClass:"nav_foot"},[_c('slider',{attrs:{"src":_vm.$t('banners.menu')}})],1)],1)]),_vm._v(" "),(!_vm.hidebottom)?_c('bottomNav'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }